import axios from 'axios'

export default {
  async create (data) {
    return axios.post('/api/experiences', data).then(r => r.data)
  },
  async get () {
    return axios.get('/api/experiences').then(r => r.data)
  },
  async update (id, data) {
    return axios.put(`/api/experiences/${id}`, data).then(r => r.data)
  },
  async delete (id) {
    return axios.delete(`/api/experiences/${id}`).then(r => r.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/experience.js